/* eslint-disable react/require-default-props, jsx-a11y/label-has-associated-control */

import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';

import './index.scss';

type SwitchProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export default function Switch({ className = '', ...otherProps }: SwitchProps) {
  return (
    <label className={`ds-switch-container ${className}`}>
      <input
        type="checkbox"
        className="d-none"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...otherProps}
      />
      <span className="ds-switch-handle" />
    </label>
  );
}
